export default __webpack_public_path__ + "static/media/product7.ff802f9c.jpg";